<div class="settings-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12">
                <div class="inbox-container">
                    <!-- Spinner global -->
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">Vă rugăm așteptați...</h3>
                        </div>
                    </div>

                    <!-- Lista de email-uri (stânga) -->
                    <div class="inbox-list" [style.width.%]="inboxListWidth">
                        <!-- Header fix cu search și controale -->
                        <div class="inbox-list__header">
                            <!-- Buton pentru collapse/expand top buttons -->
                            <button class="toggle-top-buttons" (click)="toggleTopButtons()" type="button">
                                <i class="fa-solid" [class.fa-chevron-down]="!showTopButtons"
                                    [class.fa-chevron-up]="showTopButtons"></i>
                                {{ showTopButtons ? 'Ascunde' : 'Arată' }} controale
                            </button>

                            <div class="card-container p-2" *ngIf="showCard">
                                <form [formGroup]="searchParamsForm">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Status Citite</mat-label>
                                                <mat-select formControlName="seen_status">
                                                    <mat-option *ngFor="let param of seenParameters"
                                                        [value]="param.value">
                                                        {{ param.key }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Status Redirecționate</mat-label>
                                                <mat-select formControlName="redirect_status">
                                                    <mat-option *ngFor="let param of redirectParameters"
                                                        [value]="param.value">
                                                        {{ param.key }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Status Trimise</mat-label>
                                                <mat-select formControlName="reply_status">
                                                    <mat-option *ngFor="let param of replyParameters"
                                                        [value]="param.value">
                                                        {{ param.key }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Status Înregistrate</mat-label>
                                                <mat-select formControlName="registered_status">
                                                    <mat-option *ngFor="let param of registeredParameters"
                                                        [value]="param.value">
                                                        {{ param.key }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </form>

                                <div class="row w-100">
                                    <div class="col d-flex justify-content-start">
                                        <button (click)="toggleCard()" type="button"
                                            class="btn btn-sm btn-warning closeBtn">Închide</button>
                                    </div>
                                    <div class="col buttons-submit">
                                        <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                            Resetează
                                        </button>
                                        <button (click)="applyFilters()" type="submit"
                                            class="btn btn-sm btn-primary ms-2">
                                            Aplică
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Butoane superioare -->
                            <ng-container *ngIf="showTopButtons">
                                <div class="inbox-list__top-buttons">
                                    <button class="top-btn" [class.active]="currentInboxSection === 'received'"
                                        (click)="switchInboxSection('received')">
                                        📥 Inbox
                                    </button>
                                    <button class="top-btn" [class.active]="currentInboxSection === 'favorite'"
                                        (click)="switchInboxSection('favorite')">
                                        <i class="fa-solid fa-star" style="color: #ffc107;"></i> Favorite (Inbox)
                                    </button>
                                    <button class="top-btn" [class.active]="currentInboxSection === 'sent'"
                                        (click)="switchInboxSection('sent')">
                                        <i class="fa-solid fa-share"></i> Trimise
                                    </button>
                                    <button class="top-btn refresh-button" (click)="onRefresh()">
                                        <i class="fa-solid fa-arrows-rotate"></i>
                                    </button>
                                    <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                        <img src="assets/images/filter-icon.png" alt="Filtrare" /> FILTRE
                                    </button>
                                    <div>
                                        <select [(ngModel)]="selectedRegistreActiveSwitch"
                                            class="form-control form-control-md">
                                            <option *ngFor="let option of registreActiveSwitch" [ngValue]="option.id">
                                                {{ option.name }}</option>
                                        </select>
                                    </div>
                                    <button class="top-btn selected-emails-btn"
                                        *ngIf="selectedEmailsForGenerate.length > 0 && permissionsService.hasPermission('indoc-module.inbox.generate')"
                                        (click)="onGenerateDocument()">
                                        <i class="fa-solid fa-file-lines"></i>
                                        Generează Doc. Intrare cu ({{ selectedEmailsForGenerate.length }}) e-mailuri
                                    </button>
                                    <button class="top-btn" *ngIf="selectedEmails.length > 0" (click)="onPrintEmails()">
                                        <i class="fa-solid fa-print"></i>
                                        Printează ({{ selectedEmails.length }})
                                    </button>
                                </div>

                                <div class="header-row">
                                    <div class="search-box">
                                        <input type="text" placeholder="Caută..."
                                            (keyup.enter)="onSearch($any($event.target).value)"
                                            [(ngModel)]="listPayload.filters.search" />
                                        <button class="search-btn" (click)="onSearch(listPayload.filters.search)">
                                            <i class="fa-solid fa-magnifying-glass"></i>
                                        </button>
                                    </div>

                                    <select class="per-page-select" [(ngModel)]="listPayload.pagination.perPage"
                                        (change)="onPerPageChange(listPayload.pagination.perPage)">
                                        <option *ngFor="let option of perPageOptions" [value]="option">
                                            {{ option }}
                                        </option>
                                    </select>

                                    <div class="col d-flex justify-content-end">
                                        <button type="button" class="btn btn-light action-button"
                                            [popover]="popTemplate" [adaptivePosition]="true" container="body"
                                            boundariesElement="viewport" placement="left">
                                            <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                            <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate |
                                                date
                                                : "dd.MM.yyyy" }}</span>
                                        </button>

                                        <ng-template #popTemplate>
                                            <div class="popover">
                                                <div class="row">
                                                    <div class="col d-flex justify-content-between">
                                                        <h2>Selectați intervalul</h2>
                                                        <button style="height: 40px; width: 100px"
                                                            class="btn btn-light close-btn" (click)="closePopover()">
                                                            <img src="assets/icons/close.svg" alt="Închide"
                                                                style="height: 20px; width: 20px" />
                                                            <span class="close-text">ÎNCHIDE</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="row mt-2 mb-2">
                                                    <div class="col d-flex justify-content-between">
                                                        <button type="button" class="action-button"
                                                            [class.selected]="selectedFilteringButton === 'last_0_days'"
                                                            (click)="setLastXDays(0)">
                                                            <span>AZI</span>
                                                        </button>
                                                        <button type="button" class="action-button"
                                                            [class.selected]="selectedFilteringButton === 'last_7_days'"
                                                            (click)="setLastXDays(7)">
                                                            <span>7 ZILE</span>
                                                        </button>
                                                        <button type="button" class="action-button"
                                                            [class.selected]="selectedFilteringButton === 'last_30_days'"
                                                            (click)="setLastXDays(30)">
                                                            <span>30 ZILE</span>
                                                        </button>
                                                        <button type="button" class="action-button"
                                                            [class.selected]="selectedFilteringButton === 'current_year'"
                                                            (click)="setYear(0)">
                                                            <span>AN CURENT</span>
                                                        </button>
                                                        <button type="button" class="action-button"
                                                            [class.selected]="selectedFilteringButton === 'previous_year'"
                                                            (click)="setYear(1)">
                                                            <span>AN ANTERIOR</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="datepicker-container">
                                                    <div class="col">
                                                        <div class="datepicker-header">
                                                            <div class="text">DE LA:</div>
                                                            <div class="date">{{ selectedStartDate | date : "mediumDate"
                                                                }}
                                                            </div>
                                                        </div>
                                                        <mat-card>
                                                            <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                                [(selected)]="selectedStartDate" [maxDate]="today"
                                                                [maxDate]="selectedEndDate"
                                                                (selectedChange)="rerenderDT()">
                                                            </mat-calendar>
                                                        </mat-card>
                                                    </div>
                                                    <div class="col">
                                                        <div class="datepicker-header">
                                                            <div class="text">PÂNĂ LA:</div>
                                                            <div class="date">{{ selectedEndDate | date : "mediumDate"
                                                                }}
                                                            </div>
                                                        </div>
                                                        <mat-card>
                                                            <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                                [maxDate]="today" (selectedChange)="rerenderDT()">
                                                            </mat-calendar>
                                                        </mat-card>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="inbox-controls" *ngIf="currentInboxSection !== 'sent'">
                                <span class="total-count">
                                    Total mesaje preluate: {{ totalSeenEmails }}/{{ totalEmails }}
                                </span>
                            </div>

                        </div>

                        <!-- Lista scrollable de email-uri -->
                        <div class="inbox-list__content">
                            <div *ngFor="let email of emails" class="email-item"
                                [class.selected]="selectedEmail?.id === email.id"
                                [class.unread]="email.seen === 0 && email.type !== 'redirect' && email.type !== 'reply'"
                                (click)="selectEmail(email)">
                                <div class="email-item__left">
                                    <i class="star-icon" [class.favorited]="email.favorite === 1"
                                        (click)="toggleFavorite(email, $event)">
                                        {{ email.favorite === 1 ? '★' : '☆' }}
                                    </i>

                                    <input type="checkbox" class="email-checkbox" (click)="$event.stopPropagation()"
                                        [(ngModel)]="email.selected" (change)="onEmailCheckboxChange(email)" />
                                </div>

                                <div class="email-item__content">
                                    <div class="email-item__header">
                                        <span class="email-subject">{{ email.subject }}</span>
                                        <span class="email-date">
                                            {{ email.received_date_time | date: 'dd.MM.yyyy HH:mm' : 'ro' }}
                                        </span>
                                    </div>

                                    <div class="email-from">{{ email.from_name }}</div>

                                    <div class="email-badges">
                                        <span class="badge badge-blue" *ngIf="email.doc_id">
                                            Înregistrat: {{ email.doc_intrare.reg_number }} / {{
                                            email.doc_intrare.reg_date | date : 'dd.MM.yyyy' : 'ro' }}
                                        </span>
                                        <span class="badge badge-green" *ngIf="email.attachments_count > 0">
                                            Fișiere înregistrate: {{ email.registered_attachments_count }}/{{
                                            email.attachments_count }}
                                        </span>
                                        <span class="badge badge-orange" *ngIf="email.assigned_user_id">
                                            Operator: {{email.assigned_user_name}}
                                        </span>
                                    </div>
                                </div>

                                <div class="email-item__right">
                                    <i class="fa-solid fa-reply status-icon redirect"
                                        *ngIf="email.hasRedirected === 1"></i>
                                    <i class="fa-solid fa-paper-plane status-icon reply"
                                        *ngIf="email.hasReply === 1"></i>
                                </div>
                            </div>
                        </div>

                        <!-- Paginare -->
                        <div class="inbox-list__pagination">
                            <button class="pagination-btn" [disabled]="listPayload.pagination.currentPage === 1"
                                (click)="goToFirstPage()">
                                Prima
                            </button>

                            <button class="pagination-btn" [disabled]="listPayload.pagination.currentPage === 1"
                                (click)="goToPreviousPage()">
                                Înapoi
                            </button>

                            <button *ngFor="let page of getPageNumbers()" class="pagination-btn page-number"
                                [class.active]="page === listPayload.pagination.currentPage" (click)="goToPage(page)">
                                {{ page }}
                            </button>

                            <button class="pagination-btn"
                                [disabled]="listPayload.pagination.currentPage === totalPages" (click)="goToNextPage()">
                                Înainte
                            </button>

                            <button class="pagination-btn"
                                [disabled]="listPayload.pagination.currentPage === totalPages" (click)="goToLastPage()">
                                Ultima
                            </button>

                            <!-- SECȚIUNEA NOUĂ - Navigare directă -->
                            <div class="page-jump">
                                <span class="page-jump-label">Pagina:</span>
                                <input type="number" class="page-jump-input" [(ngModel)]="pageInputValue"
                                    [placeholder]="'1-' + totalPages" min="1" [max]="totalPages"
                                    (keypress)="onPageInputKeyPress($event)" />
                                <button class="pagination-btn page-jump-btn" (click)="goToSpecificPage()"
                                    [disabled]="!pageInputValue">
                                    <i class="fa-solid fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="inbox-resizer" (mousedown)="onMouseDown($event)" [class.resizing]="isResizing">
                    </div>

                    <!-- Detalii email (dreapta) -->
                    <div class="inbox-detail" [style.width.%]="100 - inboxListWidth">
                        <div class="inbox-detail__header" *ngIf="selectedEmail">
                            <div class="detail-actions">
                                <!-- Buton Preluare: apare când emailul NU este preluat SAU când este preluat de altcineva -->
                                <button class="action-btn success" (click)="onPreluareEmail()"
                                    *ngIf="(!selectedEmail.assigned_user_id || !permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id)) && selectedEmail.type === 'received' && permissionsService.hasPermission('indoc-module.inbox.preluare')">
                                    <i class="fa-solid fa-play"></i> Preluare email
                                </button>

                                <!-- Butoane vizibile DOAR dacă utilizatorul curent ESTE cel asignat -->
                                <button
                                    *ngIf="selectedEmail.assigned_user_id && permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id) && selectedEmail.type === 'received' && permissionsService.hasPermission('indoc-module.inbox.nepreluare')"
                                    class="action-btn primary" (click)="onNepreluareEmail()">
                                    <i class="fa-solid fa-pause"></i> Nepreluare email
                                </button>
                                <button
                                    *ngIf="((selectedEmail.assigned_user_id && permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id)) || selectedEmail.type !== 'received') && permissionsService.hasPermission('indoc-module.inbox.delete')"
                                    class="action-btn danger" (click)="onDelete(selectedEmail.id)">
                                    <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete" />
                                    Șterge email
                                </button>
                                <button
                                    *ngIf="selectedEmail.assigned_user_id && permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id) && selectedEmail.type === 'received' && permissionsService.hasPermission('indoc-module.inbox.redirect')"
                                    class="action-btn warning" (click)="onForward()">
                                    <i class="fa-solid fa-share"></i> Redirecționează
                                </button>
                                <button
                                    *ngIf="selectedEmail.assigned_user_id && permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id) && selectedEmail.type === 'received' && hasUnprocessedAttachments() && permissionsService.hasPermission('indoc-module.inbox.process-file')"
                                    class="action-btn primary" (click)="processFileAll(selectedEmail.id)">
                                    <i class="fa-solid fa-upload"></i> Procesează toate fișierele
                                </button>
                                <button class="action-btn primary"
                                    *ngIf="selectedEmail && permissionsService.hasPermission('indoc-module.inbox.download-email')"
                                    (click)="onPrintEmailThread()">
                                    <i class="fa-solid fa-print"></i> Printează thread
                                </button>
                                <button class="action-btn primary" *ngIf="selectedEmail"
                                    (click)="onOpenActionHistory()">
                                    <i class="fa-solid fa-clock-rotate-left"></i> Istoric acțiuni
                                </button>
                            </div>
                        </div>

                        <div class="inbox-detail__content" *ngIf="selectedEmail">
                            <!-- Informații email -->
                            <div class="email-info-section">
                                <div class="info-row">
                                    <strong>Subiect:</strong>
                                    <span>{{ selectedEmail.subject }}</span>
                                </div>
                                <div class="info-row" *ngIf="selectedEmail.type === 'received'">
                                    <strong>De la:</strong>
                                    <span>
                                        {{ selectedEmail.from_name }} &lt;{{ selectedEmail.from_email }}&gt;
                                    </span>
                                    <i *ngIf="selectedEmail.type ==='received' && selectedEmail.assigned_user_id && permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id) && permissionsService.hasPermission('indoc-module.inbox.update-email')"
                                        style="cursor: pointer;" class="fa fa-pencil text-warning"
                                        (click)="openEditDialog(selectedEmail.from_email, 1)">
                                    </i>

                                    <ng-container
                                        *ngIf="selectedEmail.type === 'received' && selectedEmail.assigned_user_id && permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id)">
                                        <!-- Buton Adaugă în blacklist (când blacklisted === false) -->
                                        <button
                                            *ngIf="selectedEmail.blacklisted === false && permissionsService.hasPermission('indoc-module.inbox.blacklist')"
                                            class="blacklist-btn add-blacklist"
                                            (click)="addToBlacklist(selectedEmail.from_email)" type="button">
                                            <i class="fa fa-ban"></i>
                                            Adaugă în blacklist
                                        </button>

                                        <!-- Buton Șterge din blacklist (când blacklisted !== false) -->
                                        <button
                                            *ngIf="selectedEmail.blacklisted !== false && permissionsService.hasPermission('indoc-module.inbox.blacklist')"
                                            class="blacklist-btn remove-blacklist"
                                            (click)="removeFromBlacklist(selectedEmail.blacklisted.id)" type="button">
                                            <i class="fa fa-check-circle"></i>
                                            Șterge din blacklist
                                        </button>
                                    </ng-container>
                                </div>
                                <ng-container *ngIf="selectedEmail.type !== 'received'">
                                    <div class="info-row">
                                        <strong>De la:</strong>
                                        <span>{{ selectedEmail.sent_by_user_name }}</span>
                                    </div>
                                    <div class="info-row">
                                        <strong>Către:</strong>
                                        <span>{{ selectedEmail.to_name }} &lt;{{ selectedEmail.to_email }}&gt;</span>
                                    </div>
                                </ng-container>
                                <div class="info-row">
                                    <strong>CC:</strong>
                                    <span>{{ selectedEmail.to_cc || '-' }}</span>
                                    <i *ngIf="selectedEmail.type ==='received' && selectedEmail.assigned_user_id && permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id) && permissionsService.hasPermission('indoc-module.inbox.update-email')"
                                        style="cursor: pointer;" class="fa fa-pencil text-warning"
                                        (click)="openEditDialog(selectedEmail.to_cc, 2)">
                                    </i>
                                </div>
                                <div class="info-row">
                                    <strong>Dată primit:</strong>
                                    <span>{{ selectedEmail.received_date_time | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
                                </div>
                                <div class="info-row">
                                    <strong>Dată procesat:</strong>
                                    <span>{{ selectedEmail.created_date_time | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
                                </div>

                                <div class="info-badges">
                                    <span class="badge badge-blue badge-btn d-flex align-items-center gap-1"
                                        *ngIf="selectedEmail.doc_id && permissionsService.hasPermission('indoc-module.inbox.download-email')"
                                        (click)="print(selectedEmail.id)"
                                        [style.pointer-events]="selectedEmail.assigned_user_id && !permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id) ? 'none' : 'auto'"
                                        [class.disabled]="selectedEmail.assigned_user_id && !permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id)">
                                        <i *ngIf="permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id)"
                                            class="fa-solid fa-download"></i>
                                        Înregistrat: {{ selectedEmail.doc_intrare.reg_number }} / {{
                                        selectedEmail.doc_intrare.reg_date | date : "dd.MM.yyyy" : "ro" }}
                                    </span>
                                    <button *ngIf="selectedEmail.doc_id" class="action-btn download redirect"
                                        style="color: #fff" title="Deschide document"
                                        (click)="openDocument(selectedEmail.doc_id)">
                                        <i class="fa fa-external-link"></i> {{ selectedEmail.doc_id }}
                                    </button>
                                    <span class="badge badge-orange d-flex align-items-center"
                                        *ngIf="selectedEmail.assigned_user_id">
                                        Operator: {{ selectedEmail.assigned_user_name }}
                                    </span>
                                    <span class="badge badge-green d-flex align-items-center"
                                        *ngIf="selectedEmail.type_label">
                                        {{ selectedEmail.type_label }}
                                    </span>
                                </div>
                            </div>

                            <!-- Conținut Email -->
                            <div class="email-content-section">
                                <h4>Conținut Email</h4>
                                <div class="email-body" [innerHTML]="selectedEmail.body"></div>
                            </div>

                            <div class="attachments-section"
                                *ngIf="selectedEmail.attachments && selectedEmail.attachments.length > 0">

                                <h4>Atașamente ({{ selectedEmail.attachments.length }})</h4>

                                <div class="attachments-list">
                                    <div class="attachment-item" *ngFor="let attachment of selectedEmail.attachments">
                                        <!-- Checkbox pentru atașament -->
                                        <input type="checkbox" class="attachment-checkbox"
                                            *ngIf="selectedEmail.assigned_user_id && permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id) && attachment.file_path && !attachment.doc_intrare && permissionsService.hasPermission('indoc-module.inbox.generate')"
                                            (click)="$event.stopPropagation()" [(ngModel)]="attachment.selected"
                                            (change)="onAttachmentCheckboxChange(attachment)" />

                                        <div class="attachment-icon"
                                            [class.not-processed]="!attachment.processed_server">
                                            <span class="file-extension">{{ attachment.extension.toUpperCase() }}</span>
                                        </div>

                                        <div class="attachment-info">
                                            <div class="attachment-name" [title]="attachment.name_original">
                                                {{ attachment.name_original }}
                                            </div>
                                            <div class="attachment-meta" *ngIf="attachment.doc_id">
                                                <span class="meta-badge badge-btn d-flex align-items-center gap-1"
                                                    (click)="printFile(attachment.id)"
                                                    [style.pointer-events]="selectedEmail.assigned_user_id && !permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id) ? 'none' : 'auto'"
                                                    [class.disabled]="selectedEmail.assigned_user_id && !permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id)">
                                                    <i *ngIf="permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id)"
                                                        class="fa-solid fa-download"></i>
                                                    Înregistrat: {{attachment.doc_intrare.reg_number}} /
                                                    {{attachment.doc_intrare.reg_date | date : "dd.MM.yyyy" : "ro"}}
                                                </span>
                                                <button class="action-btn download redirect" style="color: #fff"
                                                    title="Deschide document" (click)="openDocument(attachment.doc_id)">
                                                    <i class="fa fa-external-link"></i> {{
                                                    attachment.doc_id }}
                                                </button>
                                            </div>
                                        </div>

                                        <button
                                            *ngIf="attachment.processed_server && permissionsService.hasPermission('indoc-module.inbox.download-file')"
                                            class="attachment-download" (click)="downloadAttachment(attachment)"
                                            [title]="'Descarcă ' + attachment.name_original">
                                            <i class="fa-solid fa-download"></i>
                                            Descarcă
                                        </button>

                                        <button
                                            *ngIf="!attachment.processed_server && permissionsService.hasPermission('indoc-module.inbox.process-file')"
                                            class="attachment-process" (click)="processFile(attachment.id)"
                                            [title]="'Procesează ' + attachment.name_original">
                                            <i class="fa-solid fa-upload"></i>
                                            Procesează fișier server
                                        </button>
                                    </div>
                                </div>

                                <!-- Butonul de generare - apare doar dacă există atașamente selectate -->
                                <button class="btn-generate-attachments"
                                    *ngIf="selectedAttachments.length > 0 && permissionsService.hasPermission('indoc-module.inbox.generate')"
                                    (click)="onGenerateDocumentWithAttachments()">
                                    <i class="fa-solid fa-file-lines"></i>
                                    Generează Doc. Intrare cu ({{ selectedAttachments.length }}) atașamente
                                </button>
                            </div>

                            <!-- Secțiune răspuns -->
                            <div *ngIf="selectedEmail.type === 'received' && selectedEmail.assigned_user_id && permissionsService.isAuthenticatedUser(selectedEmail.assigned_user_id) && permissionsService.hasPermission('indoc-module.inbox.reply')"
                                class="reply-section">
                                <h4>Trimite răspuns</h4>

                                <angular-editor [(ngModel)]="replyBody" [config]="editorConfig"></angular-editor>

                                <div class="solicitare-card__upload my-3">
                                    <div class="solicitare-card__upload-header">
                                        <p class="upload-text">Documente</p>
                                        <button class="upload-btn" (click)="fileInput.click()" type="button">
                                            <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                            ÎNCARCĂ
                                        </button>
                                    </div>

                                    <!-- Afișare când sunt fișiere încărcate -->
                                    <div class="solicitare-card__upload-files"
                                        *ngIf="uploadedFiles.length > 0 && !uploading">
                                        <div class="solicitare-card__upload-file"
                                            *ngFor="let uploadedFile of uploadedFiles; let i = index">
                                            <span class="solicitare-card__upload-file-name">
                                                {{ uploadedFile.original_name.length > 30 ? (uploadedFile.original_name
                                                | slice : 0 : 30) + ".." : uploadedFile.original_name }}
                                            </span>
                                            <div class="d-flex gap-4 align-items-center">
                                                <button class="solicitare-card__upload-file-view" type="button"
                                                    matTooltip="Vizualizează fișierul"
                                                    (click)="downloadFile(uploadedFile)">
                                                    <mat-icon class="btn-icon">visibility</mat-icon>
                                                    <span class="btn-text">Vizualizează</span>
                                                </button>
                                                <button class="solicitare-card__upload-file-delete" type="button"
                                                    matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                                                    <img class="btn-img" src="../../../assets/icons/delete.svg"
                                                        alt="" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Mesaj când nu sunt fișiere -->
                                    <div class="solicitare-card__upload-files"
                                        *ngIf="uploadedFiles.length === 0 && !uploading">
                                        <div class="solicitare-card__upload-file">
                                            <div class="w-100 text-center">
                                                <strong><i>Lipsă înregistrări</i></strong>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Spinner când se încarcă -->
                                    <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                        *ngIf="uploading"></mat-spinner>

                                    <input type="file"
                                        accept=".png, .jpg, .jpeg, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ods, .odt, .heic"
                                        id="upload-file-input-0" #fileInput name="fileInput" (change)="addFile($event)"
                                        multiple style="display: none" />
                                </div>

                                <div class="reply-actions">
                                    <button type="button" class="btn btn-success" (click)="onReply()"
                                        [disabled]="!replyBody || !selectedEmail.assigned_user_id">
                                        Răspunde
                                    </button>
                                    <button type="button" class="btn btn-info" (click)="onTemplates()">
                                        Șabloane
                                    </button>
                                </div>
                            </div>

                            <!-- Istoric Mesaje -->
                            <div class="history-section" *ngIf="selectedEmail.historyMessages?.length > 0">
                                <h4>Istoric Mesaje</h4>

                                <div *ngFor="let msg of selectedEmail.historyMessages" class="history-item"
                                    [class.expanded]="isHistoryMessageExpanded(msg.id)">

                                    <div class="history-header"
                                        (click)="msg.body !== '' ? toggleHistoryMessage(msg.id) : null"
                                        [class.no-expand]="msg.body === ''">
                                        <div class="history-header-left">
                                            <span class="history-type">{{ msg.type_label }}</span>
                                            <span class="history-date">
                                                {{ msg.sent_date_time | date: 'dd.MM.yyyy HH:mm:ss' }}
                                            </span>
                                        </div>
                                        <i *ngIf="msg.body !== ''" class="expand-icon fa-solid"
                                            [class.fa-chevron-down]="!isHistoryMessageExpanded(msg.id)"
                                            [class.fa-chevron-up]="isHistoryMessageExpanded(msg.id)"></i>
                                    </div>

                                    <div class="history-preview">
                                        <p><strong>De la:</strong> {{ msg.sent_by_user_name ? msg.sent_by_user_name :
                                            msg.from_name }} &lt;{{ msg.from_email }}&gt;</p>
                                        <p><strong>Către:</strong> {{ msg.to_name }} &lt;{{ msg.to_email }}&gt;</p>
                                        <p><strong>Subiect:</strong> {{ msg.subject }}</p>
                                        <p *ngIf="msg.to_cc"><strong>CC:</strong> {{ msg.to_cc }}</p>
                                        <p *ngIf="msg.attachments_count > 0">
                                            <strong>Atașamente:</strong> {{ msg.attachments_count }}
                                        </p>

                                        <!-- Preview al conținutului -->
                                        <div class="history-preview-body"
                                            *ngIf="!isHistoryMessageExpanded(msg.id) && msg.body !== ''">
                                            <span class="preview-text">{{ getPlainTextPreview(msg.body, 120) }}</span>
                                        </div>
                                    </div>

                                    <div class="history-body" *ngIf="isHistoryMessageExpanded(msg.id)">
                                        <div class="history-body-content" [innerHTML]="msg.body"></div>

                                        <!-- Secțiune atașamente pentru mesajul din istoric -->
                                        <div class="history-attachments"
                                            *ngIf="msg.attachments && msg.attachments.length > 0">
                                            <h5>Atașamente ({{ msg.attachments.length }})</h5>

                                            <div class="attachments-list">
                                                <div class="attachment-item" *ngFor="let attachment of msg.attachments">
                                                    <div class="attachment-icon"
                                                        [class.not-processed]="!attachment.processed_server">
                                                        <span class="file-extension">
                                                            {{ attachment.extension.toUpperCase() }}
                                                        </span>
                                                    </div>

                                                    <div class="attachment-info">
                                                        <div class="attachment-name" [title]="attachment.name_original">
                                                            {{ attachment.name_original }}
                                                        </div>
                                                        <div class="attachment-meta" *ngIf="attachment.doc_id">
                                                            <span class="meta-badge">
                                                                Înregistrat: {{ attachment.doc_id }}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <button
                                                        *ngIf="attachment.processed_server && permissionsService.hasPermission('indoc-module.inbox.download-file')"
                                                        class="attachment-download"
                                                        (click)="downloadHistoryAttachment(attachment, $event)"
                                                        [title]="'Descarcă ' + attachment.name_original">
                                                        <i class="fa-solid fa-download"></i>
                                                        Descarcă
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="inbox-detail__empty" *ngIf="!selectedEmail">
                            <p>Vă rugăm selectați un email</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>